import { toDate } from "./toDate.js";

import { getMonth as coreGetMonth } from "./_core/getMonth.js";

/**
 * The {@link getMonth} function options.
 */

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
export function getMonth(date, options) {
  return coreGetMonth(toDate(date, options?.in));
}

// Fallback for modularized imports:
export default getMonth;
